import { render, staticRenderFns } from "./buyresult.vue?vue&type=template&id=43eed07e&scoped=true&"
import script from "./buyresult.vue?vue&type=script&lang=js&"
export * from "./buyresult.vue?vue&type=script&lang=js&"
import style0 from "./buyresult.vue?vue&type=style&index=0&lang=less&"
import style1 from "./buyresult.vue?vue&type=style&index=1&id=43eed07e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eed07e",
  null
  
)

export default component.exports